// extracted by mini-css-extract-plugin
export default {"contentContainer":"promotion_contentContainer__n9vYR","subTitle":"promotion_subTitle__v3saM","dropdown":"promotion_dropdown__ohPDr"};